import React from "react";

const ProductDescription = ({ productInfo }) => {

  // Reusable Product Description Renderer
  function ProductDescriptions({ productInfo }) {
    return (
      <>
        {productInfo &&
          productInfo.map((item, index) =>
            item ? (
              <div className="w-full relative group" key={item._id}>
                <div className="border-b border-gray-300 py-4 grid grid-cols-4 gap-4">
                  
                  {/* SEO Image Optimization */}
                  <div className="pdptypesimg">
                    <img
                      className="object-cover"
                      src={item.img}
                      alt={`${item.productName} high-quality export product image`}
                      loading="lazy"
                    />
                  </div>

                  {/* SEO Content */}
                  <div className="flex flex-col gap-2 font-titleFont col-span-3">
                    <h3 className="text-lg font-semibold">
                      {item.productName}
                    </h3>

                    <p className="text-sm font-medium text-gray-700 leading-relaxed">
                      {item.des}
                    </p>

                    {/* Keyword-Rich Heading for Types */}
                    {item.types && item.types.length > 0 && (
                      <p className="text-base font-semibold mt-2">
                        Available Types of {item.productName}:
                      </p>
                    )}

                    {/* Types of Products (SEO Structured Data Style UI) */}
                    {item.types &&
                      item.types.map((types, index1) =>
                        types ? (
                          <div
                            key={types._id}
                            className="flex flex-col gap-1 font-titleFont pl-4"
                          >
                            <h4 className="text-base font-semibold">
                              {index1 + 1}. {types.productName}
                            </h4>

                            <p className="text-sm text-gray-700 leading-relaxed">
                              {types.des}
                            </p>
                          </div>
                        ) : (
                          ""
                        )
                      )}
                  </div>
                </div>
              </div>
            ) : (
              ""
            )
          )}
      </>
    );
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-1 gap-10 mdl:gap-4 lg:gap-10">
      {/* Category Render Component */}
      <ProductDescriptions productInfo={productInfo.categ} />
    </div>
  );
};

export default ProductDescription;
